import { DashboardUserMenu } from '@/widgets/dashboard-user-menu'
import { InputField } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'
import { cn } from '@/shared/lib'

type DashboardProfileDesktopProps = {
  className?: string
}

const desktopSectionGap = designTokens.components.account.layout.sectionGap

const searchInputContainerStyle = {
  maxWidth: designTokens.components.account.search.width,
}

const searchInputStyle = {
  height: designTokens.components.account.search.height,
  backgroundColor: designTokens.colors.background.glass,
  borderRadius: designTokens.borders.radius.sm,
  border: `${designTokens.borders.widths.thin} ${designTokens.borders.styles.solid} ${designTokens.colors.border.adminPattern}`,
  paddingRight: designTokens.components.account.search.paddingRight,
  fontFamily: designTokens.typography.fontFamilies.primary,
  ...typographyStyle(designTokens.typography.body.base),
  color: designTokens.colors.text.primary,
}

const titleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.strong,
  ...typographyStyle(designTokens.typography.heading.h2),
}

const bodyStyle = {
  color: designTokens.colors.text.primary,
  fontFamily: designTokens.typography.fontFamilies.primary,
  ...typographyStyle(designTokens.typography.body.base),
}

export function DashboardProfileDesktop({ className }: DashboardProfileDesktopProps) {
  return (
    <div
      className={cn('hidden w-full flex-col lg:flex', className)}
      style={{ gap: desktopSectionGap }}
    >
      <div
        className="flex w-full items-center justify-between"
        style={{ gap: designTokens.spacing.xxl }}
      >
        <InputField
          type="search"
          placeholder="Поиск"
          aria-label="Поиск"
          variant="search"
          containerClassName="w-full"
          containerStyle={searchInputContainerStyle}
          inputClassName="w-full bg-transparent outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
          style={searchInputStyle}
        />
        <DashboardUserMenu />
      </div>
      <section className="flex w-full flex-col" style={{ gap: designTokens.spacing.lg }}>
        <h1 style={titleStyle}>Мой профиль</h1>
        <p style={bodyStyle}>Контент профиля будет добавлен в DOC-0023.</p>
      </section>
    </div>
  )
}

DashboardProfileDesktop.displayName = 'DashboardProfileDesktop'
